module.exports = __webpack_public_path__ + "img/fernandito.03e0212c.jpg";